export default "__VITE_ASSET__BPw6fWyp__"